import { useAuth } from '../lib/auth'
import { useTheme } from '../lib/theme'
import type { ThemeChoice } from '../lib/theme'
import { formatDate, titleCase } from '../lib/format'
import { Badge, Button, Card, CardBody, CardHeader } from '../components/ui'

export default function Profile() {
  const { user } = useAuth()
  const { choice, set } = useTheme()

  const rows: Array<[string, string]> = [
    ['Full name', user?.full_name || '—'],
    ['Email', user?.email || '—'],
    ['Phone', user?.phone || '—'],
    ['National ID', user?.national_id || '—'],
    ['Role', titleCase(user?.role)],
    ['Tier', titleCase(user?.tier)],
    ['Cooperative', user?.org_id || 'Not linked'],
    ['Region', user?.region_id || '—'],
    ['District', user?.district_id || '—'],
    ['Member since', formatDate(user?.created_at)],
  ]

  const themes: Array<[ThemeChoice, string]> = [
    ['light', 'Light'], ['dark', 'Dark'], ['system', 'System'],
  ]

  return (
    <>
      <div className="page-head">
        <div>
          <h1>Profile &amp; settings</h1>
          <p className="page-head__sub">Your account details and app preferences.</p>
        </div>
      </div>

      <div className="stack">
        <Card>
          <CardHeader
            title="Account"
            sub="Managed by your cooperative administrator"
            action={user?.status ? <Badge tone={user.status === 'active' ? 'success' : 'warning'} dot>
              {titleCase(user.status)}
            </Badge> : undefined}
          />
          <CardBody flush>
            <div className="table-wrap">
              <table className="table">
                <tbody>
                  {rows.map(([label, value]) => (
                    <tr key={label}>
                      <th style={{ width: 200, textTransform: 'none', letterSpacing: 0, fontSize: 'var(--text-sm)' }}>
                        {label}
                      </th>
                      <td>{value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </CardBody>
        </Card>

        <Card>
          <CardHeader title="Appearance"
                      sub="Applies to this browser only." />
          <CardBody>
            <div className="row">
              {themes.map(([value, label]) => (
                <Button
                  key={value}
                  size="sm"
                  variant={choice === value ? 'primary' : 'secondary'}
                  onClick={() => set(value)}
                >
                  {label}
                </Button>
              ))}
            </div>
          </CardBody>
        </Card>

        <Card>
          <CardHeader title="Changing your details" />
          <CardBody>
            <p style={{ color: 'var(--text-muted)', fontSize: 'var(--text-sm)' }}>
              Name, role, cooperative and region are set by your administrator so
              that licensing records stay consistent. To correct any of them,
              contact your cooperative leader or the Ministry.
            </p>
          </CardBody>
        </Card>
      </div>
    </>
  )
}
